
import { mostrarAvisoNuevoLogin } from "@/auth/avisoLogin";
import { AvisoNuevoLogin } from "@/components/AvisoNuevoLogin";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useIdentity } from "@/auth/identity";

const LoginPage = () => {
  const { isAuthenticated, loginWithRedirect, provider } = useIdentity();
  const navigate = useNavigate();

  // Si el usuario ya está autenticado, redirigir al dashboard
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-primary p-4">
      <div className="w-full max-w-md p-6 bg-card rounded-lg shadow-xl">
        <div className="text-center mb-8">
          <img src="/millana-isotipo.svg" alt="" className="mx-auto mb-4 h-16 w-auto" />
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">Millana</h1>
          <p className="text-muted-foreground mt-2">App de choferes</p>
        </div>

        <Button
          className="w-full py-6 text-lg"
          onClick={() => loginWithRedirect()}
        >
          Iniciar sesión
        </Button>

        {/* El login de Cognito rotula el campo "Nombre de usuario", pero se entra con el email. */}
        {mostrarAvisoNuevoLogin(provider) ? (
          <AvisoNuevoLogin />
        ) : (
          provider === "cognito" && (
            <p className="text-center text-foreground text-sm mt-4">Ingresá con tu email y tu DNI.</p>
          )
        )}

        <p className="text-center text-muted-foreground text-sm mt-6">
          Acceso exclusivo para equipo de transporte
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
